<template>
  <v-dialog
    v-model="show"
    persistent
    width="375"
  >
    <v-card>
      <v-card-title
        class="title"
      >
        お知らせ
      </v-card-title>

      <v-card-text class="mt-10 text" v-html="message" />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-1"
          dark
          text
          to="/teacher/home"
        >
          ホーム画面へ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    show: false,
    type: 'notice',
  }),

  methods: {
    open(type) {
      this.show = true;
      this.type = type;
    },

    close() {
      this.show = false;
    }
  },

  computed: {
    remainDownloadCount() {
      return this.$store.state.user.remainingDownloadCount
    },

    // おためし活動アカウント(uidが「o-」始まり)か
    isOtameshi() {
      return this.$store.state.user.uid?.startsWith('o-')
    },

    // おためし版のため回数制限がある旨の文言(太赤字)
    otameshiAttention() {
      return this.isOtameshi ? '<span style="color:red;font-weight:bold;">（おためし版のため回数制限がございます）</span>' : ''
    },

    message() {
      if (this.type === 'alert') {
        return `残りダウンロード回数が残っていません。${this.otameshiAttention}<br>お問い合わせいただく場合は、弊社特約店までご連絡ください。`
      }
      return `あと残り${this.remainDownloadCount}回ダウンロードできます。${this.otameshiAttention}<br><br>Word・Excelをお持ちでない方は、申し込み履歴からＰＤＦデータをダウンロードすることができます。`
    }
  }
}
</script>

<style lang="stylus" scoped>
.title
  justify-content center
  background-image linear-gradient(to right, #2465a2, #3d79a8, #1d73aa)
  color white

.text
  justify-content center
  font-size 16px
  font-weight bold
</style>
